import http from './http.service';
import axios from 'axios';

class PublicPageService {
    constructor() {
        if (PublicPageService.instance) {
            return PublicPageService.instance;
        }

        PublicPageService.instance = this;
    }

    ipData() {
        return http.get('/public/ip-data').then(res => res.data);
    }
    vehicles() {
        return http.get('/public/vehicles').then(res => res.data);
    }
    pages() {
        return http.get('/public-page').then(res => res.data);
    }
    show(pageId) {
        return http.get(`/public-page/${pageId}/show`).then(res => res.data);
    }
    publicShow(name) {
        return http.get('/public-page/show', { params: {name} }).then(res => res.data);
    }
    update(pageId, data) {
        return http.put(`/public-page/${pageId}/update`, data).then(res => res.data);
    }
}

export default new PublicPageService();
